import React, { Component } from 'react';
import './Comments.css';
import Parser from "html-react-parser";
import Moment from 'react-moment';
import 'moment/locale/fr';

const commentPropertyChanged = (key, val) => ({ form }) => ({
    form: {...form, [key]: val}
});

class Comments extends Component {

    constructor(props) {
        super(props);
        this.state = {
            form: {
                pseudo: '',
                mail: '',
                url: '',
                text: ''
            }
        };
        this.sendComment = this.sendComment.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = e => {
        this.setState(commentPropertyChanged(e.target.name, e.target.value));
    };

    sendComment(event) {
        event.preventDefault();
        if (this.props.recipeId) {
            this.props.postComment(this.props.recipeId, this.props.recipeLabel, this.state.form);
        } else {
            this.props.postPartnerComment(this.props.partnerId, this.props.partnerLabel, this.state.form);
        }
        this.setState({
            form: {
                pseudo: '',
                mail: '',
                url: '',
                text: ''
            }
        });
    }

    render() {
        const { comments, totalComments } = this.props;
        const { form } = this.state;

        return (
            <div className="comments">
                <div className="comments-title">COMMENTAIRES</div>
                Tu as aimé ma recette ? Tu souhaites la tester ? Tu as des questions ? Laisse moi donc un commentaire !
                <form className="comments-form" onSubmit={this.sendComment}>
                    <div className="comments-form__inputs">
                        <input name="pseudo" value={form.pseudo} placeholder="Pseudo" required onChange={this.handleChange}  />
                        <input name="mail" value={form.mail} placeholder="Mail" type="email" required onChange={this.handleChange}  />
                        <input name="url" value={form.url} placeholder="Site Web" type="url" onChange={this.handleChange} />
                    </div>
                    <div className="comments-form__comment">
                        <textarea name="text" className="comments-form__comment-textarea" value={form.text} required onChange={this.handleChange} ></textarea>
                        <input type="submit" className="comments-form__comment-submit" value="Publier"></input>
                    </div>
                </form>
                <div className="comments-total">{totalComments} commentaire(s)</div>
                <div className="comments-list">
                    { comments && comments.map(comment =>
                        <div key={comment.id} className="comments-list-element">
                            <i className="fa fa-quote-left"></i>
                            <div className="comments-list-element__content">{Parser(comment.text)}</div>
                            <i className="fa fa-quote-right"></i>
                            <div className="comments-list-element__infos">
                                <a className="comments-infos--link" href={comment.url}>{ comment.pseudo }</a> le <Moment format="DD MMMM YYYY">{comment.date}</Moment>
                            </div>
                        </div>
                    )}
                </div>
                { totalComments === 0 &&
                    <div className="no-comment">
                        <p>Aucun commentaire</p>
                    </div>
                }
            </div>
        );
    }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/components/Comments.js